import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";

import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {AssetsGroup} from "@nolimitcity/slot-game/bin/asset/Asset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {Game} from "../Game";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

export class IntroConfig implements GameIntroViewConfig {
    public static _assetLoader: AssetLoader;
    colors: GameIntroColors = {
        slideShowColors: {
            backgroundColor: 0x000000, //Default 0x000000
            backgroundAlpha: 0, //Default 0.4
            bulletColor: 0xffffff, //Default 0xffffff
        },
        stampColor: 0xFFFFFF
    };
    stampConfig: StampConfig = {
        xWays: true,
        xNudge: true,
        xHole:true,
        xGod:true,
        xBet: true,
        xSplit:true,
        volatility: Volatility.INSANE,
        xMental:true
    };
    background: PIXI.Container;
    borderBottom: PIXI.Container;
    borderTop: PIXI.Container;
    logo: PIXI.Container;
    pages: SlideShowPage[];

    constructor() {
    }

    public init(): Promise<GameIntroViewConfig> {
        const imgLoader: ImgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("introBg", "resources/images/intro_BG.png");

        imgLoader.add("feature1", "resources/images/intro_xMental_05.png");
        imgLoader.add("feature2", "resources/images/intro_xHole_04.png");
        imgLoader.add("feature3", "resources/images/intro_xGod_06.png");
        imgLoader.add("feature4", "resources/images/intro_feature_01.png");
        imgLoader.add("feature5", "resources/images/intro_feature_02.png");
        imgLoader.add("feature4_us", "resources/images/intro_feature_01_US.png");
        imgLoader.add("feature5_us", "resources/images/intro_feature_02_US.png");
        imgLoader.add("feature6", "resources/images/intro_feature_03.png");

        imgLoader.add("logo", "resources/images/introLogo.png");

        imgLoader.add("gameIntro", "resources/images/game_intro_assets/gameIntro.json");

        const assetsGroup: AssetsGroup = {
            name: "spine",
            assets: [
                new SpineAsset("gameIntro", "images/game_intro.json"),
            ]
        };

        AssetsConfig.addToAssetsConfig({
            "main": [],
            "intro": [assetsGroup]
        });
        IntroConfig._assetLoader = new AssetLoader(Game.apiPlugin, NolimitApplication.resourcePath + "/resources/");

        const promises: Promise<any> = Promise.all([imgLoader.load(), IntroConfig._assetLoader.load(ResourcesGroupName.INTRO)]);

        return promises.then(value => {
            this.initGraphics();
            return this;
        });
    }

    private initGraphics() {
        this.background = new PIXI.Container();
        const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introBg"));
        bgSprite.name = "bgSprite";
        bgSprite.anchor.set(0.5, 0.5);
        this.background.addChild(bgSprite);

        this.borderTop = new PIXI.Container();
        this.borderBottom = new PIXI.Container();

        this.logo = new PIXI.Container();
        const logoSprite = new PIXI.Sprite(ImgLoader.getImgTexture("logo"));
        logoSprite.anchor.set(0.5, 0.5);
        this.logo.addChild(logoSprite);
        if (Game.apiPlugin.gameClientConfiguration.isSet) {
            this.loadPages();
        } else {
            Game.apiPlugin.events.once(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                this.loadPages();
            });
        }
    }

    private loadPages(){
        const usPostFix : string = Game.apiPlugin.gameClientConfiguration.showMultipliersInfo ? "":"_us";
        this.pages = [
            new SlideShowPage(ImgLoader.getImgTexture("feature1")),
            new SlideShowPage(ImgLoader.getImgTexture("feature2")),
            new SlideShowPage(ImgLoader.getImgTexture("feature3")),
            new SlideShowPage(ImgLoader.getImgTexture("feature4" + usPostFix)),
            new SlideShowPage(ImgLoader.getImgTexture("feature5" + usPostFix)),
            new SlideShowPage(ImgLoader.getImgTexture("feature6")),
        ];
        this.pages.forEach((page) => {
            (page.children[0] as PIXI.Sprite).anchor.set(0.5);
        })
    }
}
